import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useLogin } from "../context/LoginContext";
import { supabase } from "../supabase/client";

import TitleBox from "../components/common/TitleBox";
import ContainerBox from "../components/common/ContainerBox";
import Button from "../components/common/Button";
import TableData from "../components/common/TableData";
import {
  IconEdit,
  IconMail,
  IconPdf,
  IconPlus,
  IconTrash,
} from "../components/icons/Icons";
import Modal from "../components/common/Modal";
import LettersForm from "../components/forms/LettersForm";
import { useDataBase } from "../context/DataBaseContext";
import NotificationForm from "../components/forms/NotificationForm";

const ResolucionesPage = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isModalOpenNotification, setIsModalOpenNotification] = useState(false);
  const [idData, setIdData] = useState(null);
  const { resoluciones, getResoluciones } = useDataBase();

  const navigate = useNavigate();
  const { user } = useLogin();

  useEffect(() => {
    if (user !== null) {
      navigate("/resoluciones");
    }
    getResoluciones();
  }, [user]);

//   console.log(resoluciones);

  const columns = [
    {
      header: "Código",
      accessorKey: "number",
    },
    {
      header: "Expediente",
      accessorFn: (row) =>
        row.process !== null
          ? `${row.process.num_process}-${row.process.anio_process}-${row.process.class_process.name}`
          : "",
    },
    {
      header: "Descripción",
      accessorKey: "description",
    },
    {
      header: "F. resol.",
      accessorFn: (row) => `${row.date_resolution.split("T")[0]}`,
    },
    // {
    //   header: "F. envío",
    //   accessorFn: (row) => `${row.sending_date.split("T")[0]}`,
    // },
    // {
    //   header: "F. noti.",
    //   accessorFn: (row) => `${row.notification_date.split("T")[0]}`,
    // },
    {
      header: "Secretario",
      accessorFn: (row) =>
        `${row.secretaries.users.first_name} ${row.secretaries.users.last_name}`,
    },
    {
      header: "Visualiza",
      cell: ({ cell }) => {
        const award = cell.row.original.award;
        const id = cell.row.original.id;
        return (
          <button
            className={`flex items-center justify-center text-xs capitalize text-white rounded-full w-14 h-5 ${
              award === true ? "bg-success " : "bg-danger/40"
            }`}
            type="button"
            onClick={() => handleAwardChange(id, award)}
          >
            {award ? "Si" : "No"}
          </button>
        );
      },
    },
    {
      header: "Documentos",
      cell: ({ cell }) => {
        const award = cell.row.original.award;
        //   const id = cell.row.original.id;
        return (
          <div className="flex items-center">
            <a
              href={"cv/" + award}
              target="_blank"
              rel="noreferrer"
              className={`${
                award !== null
                  ? `bg-orange-400/80 hover:bg-orange-400 border-orange-400/80`
                  : `bg-secondary/30 border-secondary/10 pointer-events-none cursor-none`
              } border text-xs text-white px-2 py-1 rounded-sm`}
              title="Resolución"
            >
              <IconPdf className="w-4" />
            </a>
            <a
              href={"cv/" + award}
              target="_blank"
              rel="noreferrer"
              className={`${
                award !== null
                  ? `bg-primary/80 hover:bg-primary border-primary/80`
                  : `bg-secondary/30 border-secondary/10 pointer-events-none cursor-none`
              } border text-xs text-white px-2 py-1 rounded-sm`}
              title="Notificación"
            >
              <IconPdf className="w-4" />
            </a>
          </div>
        );
      },
    },
    {
      header: "Acciones",
      cell: ({ cell }) => {
        const id = cell.row.original.id;
        // const file = cell.row.original.resolution_file;
        return (
          <div className="flex items-center">
            <button
              className="bg-success/80 hover:bg-success border border-success/80 text-xs text-white px-2 py-1 rounded-sm"
              title="Notificar"
              onClick={() => {
                openModalNotification(id)
                setIdData(id);
            }}
            >
              <IconMail className="w-4" />
            </button>
            <button
              className="bg-warning/80 hover:bg-warning border border-warning/80 text-xs text-black/50 px-2 py-1 rounded-sm"
              title="Editar"
              onClick={() => openModal(id)}
            >
              <IconEdit className="w-4" />
            </button>
            <button
              className="bg-danger/90 hover:bg-danger border border-danger/90 text-xs text-white px-2 py-1 rounded-sm"
              title="Eliminar"
              onClick={openModal}
            >
              <IconTrash className="w-4" />
            </button>
          </div>
        );
      },
    },
  ];

  const handleAwardChange = async (id, status) => {
    const { error } = await supabase
      .from("resolutions")
      .update({
        award: !status,
      })
      .eq("id", id);
    if (error) console.log("error", error);
    getResoluciones();
  };

  const openModal = (id = null) => {
    setIsModalOpen(true);
    setIdData(id);
    // getModal()
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  const openModalNotification = () => {
    setIsModalOpenNotification(true);
    // setIdData(id);
    // getModal()
  };

  return (
    <>
      <TitleBox title="Relación de resoluciones" />
      <ContainerBox>
        <Button value="Nuevo" openModal={() => openModal()}>
          <IconPlus className="w-4" />
        </Button>
        <TableData columns={columns} data={resoluciones} />
      </ContainerBox>
      <Modal
        isOpen={isModalOpen}
        onClose={closeModal}
        isModal={false}
        title={"Nuevo registro"}
      >
        <LettersForm idData={idData} onClose={closeModal} />
      </Modal>
      <Modal
        isOpen={isModalOpenNotification}
        onClose={() => setIsModalOpenNotification(false)}
        title={"Notificación virtual"}
      >
        <NotificationForm idData={idData} />
      </Modal>
    </>
  );
};

export default ResolucionesPage;
